import { __awaiter } from "tslib";
import { Environment, AppEnvironmentUtil } from '@as-react/common-utils';
const configureStore = () => __awaiter(void 0, void 0, void 0, function* () {
    if (Environment.isProduction() && AppEnvironmentUtil.isProduction()) {
        const configureNoDebugStore = yield import('./storeConfigure.noDebug');
        return new configureNoDebugStore.StoreConfiguratorNoDebug();
    }
    const configureLocalDebugStore = yield import('./storeConfigure.localDebug');
    return new configureLocalDebugStore.StoreConfiguratorLocalDebug();
});
export default configureStore;
